import { init } from '@ln/user.client.libs';

function UserClientLibs() {
    return init({ keyDatadog: process.env.REACT_APP_DD_CLIENT_TOKEN });
}

const UCL = UserClientLibs();

export default UCL;